import * as React from "react";
import "./BOTableStyle.css";
import * as FontAwesome from "react-fontawesome";

type Props = {
  name: string;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  loading?: boolean;
  header?: JSX.Element;
  columns?: JSX.Element;
  body?: JSX.Element;
  footer?: JSX.Element;
};

export default class BOTable extends React.Component<Props, {}> {
  scroll = (e: any) => {
    var translate = "translate(0," + e.target.scrollTop + "px)";
    e.target.firstChild.firstChild.style.transform = translate;
  };

  render() {
    const { name, header, body, footer, columns, loading } = this.props;

    const loader = () => {
      return (
        <tbody>
          <tr className="BOTable_Loader">
            <td>
              <FontAwesome
                name="spinner"
                spin={true}
                size="2x"
                style={{
                  textShadow: "1px 1px 2px #4c5a86",
                  color: "#313d61"
                }}
              />
            </td>
          </tr>
        </tbody>
      );
    };

    return (
      <div className="BOTable_Container">
        {header}
        <div className="BOTable_Scroll_Handler" onScroll={e => this.scroll(e)}>
          <table
            cellSpacing={0}
            cellPadding={0}
            id={`BOTable_${name}`}
            className="BOTable"
          >
            {loading ? loader() : null}
            {columns ? <thead>{columns}</thead> : null}
            {body}
          </table>
        </div>
        {footer}
      </div>
    );
  }
}

const BOHeaderTitle = (props): JSX.Element => {
  return props.title ? <h3 className="BOTable_Title">{props.title}</h3> : null;
};

export const BOHeader = (props): JSX.Element => {
  return (
    <div className="BOTable_Header">
      <BOHeaderTitle {...props} />
      {props.children}
    </div>
  );
};

export const BOFooter = (props): JSX.Element => {
  return <div className="BOTable_Footer">{props.children}</div>;
};

export const BOColumns = (props): JSX.Element => {
  return <tr>{props.children}</tr>;
};

export const BOColumn = (props): JSX.Element => {
  let thClass = props.className ? props.className : "";
  switch (props.align) {
    case "right":
      thClass += " align-r";
      break;
    case "center":
      thClass += " align-c";
      break;
    case "left":
    default:
      thClass += " align-l";
      break;
  }

  const thProps = {
    colSpan: props.colSpan ? props.colSpan : 1,
    className: thClass
  };

  return <th {...thProps}>{props.children}</th>;
};

export const BOBody = (props): JSX.Element => {
  return <tbody onClick={props.onClick}>{props.children}</tbody>;
};

export const BORow = (props): JSX.Element => {
  let trClass = props.className ? props.className : "";
  let trStyle = props.style ? props.style : {};
  if (props.rowColor) {
    trStyle["backgroundColor"] = trStyle["backgroundColor"]
      ? trStyle["backgroundColor"]
      : props.rowColor;
  }

  const trProps = {
    href: props.href,
    colSpan: props.colSpan ? props.colSpan : 1,
    className: trClass,
    style: trStyle
  };

  if (props.href) {
    trProps.className += " clickable-row";
  }

  return <tr {...trProps}>{props.children}</tr>;
};

export const BOCell = (props): JSX.Element => {
  let tdClass = props.className ? props.className : "";
  switch (props.align) {
    case "right":
      tdClass += " align-r";
      break;
    case "center":
      tdClass += " align-c";
      break;
    case "left":
    default:
      tdClass += " align-l";
      break;
  }

  const tdProps = {
    colSpan: props.colSpan ? props.colSpan : 1,
    rowSpan: props.rowSpan ? props.rowSpan : 1,
    className: tdClass
  };

  return <td {...tdProps}>{props.children}</td>;
};

type BOPaginationProps = {
  offset: number;
  limit: number;
  dataLength: number;
  onPrev: () => void;
  onNext: () => void;
};

export const BOPagination = (props: BOPaginationProps): JSX.Element => {
  const paginatePrev = () => {
    if (props.offset !== 0) {
      return (
        <button
          className="button"
          style={{ margin: "5px", padding: "4px", width: "30px" }}
          onClick={props.onPrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
      );
    } else {
      return null;
    }
  };

  const paginateNext = () => {
    if (props.dataLength < props.limit) {
      return null;
    } else {
      return (
        <button
          className="button"
          style={{ margin: "5px", padding: "4px", width: "30px" }}
          onClick={props.onNext}
        >
          <i className="fa fa-chevron-right" />
        </button>
      );
    }
  };

  return (
    <>
      {paginatePrev()}
      Page {props.offset / props.limit + 1}
      {paginateNext()}
    </>
  );
};
